import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  ISettingsNotificationsResponse,
  ISettingsNotificationsSavePayload,

} from '../types';
import {
  ADMIN_GENERAL_SETTINGS_NOTIFICATIONS_PERMISSIONS,
  SETTINGS_NOTIFICATIONS_SAVE_QUERY_KEY,
  SETTINGS_NOTIFICATIONS_SAVE_URL,

} from '../constants';

export default function useSettingsNotificationsSaveMutation(): ReturnType<
  typeof useContextMutation<ISettingsNotificationsResponse, Error, ISettingsNotificationsSavePayload>
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingsNotificationsResponse,
    Error,
    ISettingsNotificationsSavePayload
  >({
    mutationKey: [SETTINGS_NOTIFICATIONS_SAVE_QUERY_KEY],
    mutationFn: (payload) => fetchPut<ISettingsNotificationsResponse>(
      SETTINGS_NOTIFICATIONS_SAVE_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_NOTIFICATIONS_PERMISSIONS.NOTIFICATIONS_SHOW,
        urlParams: {
          id: payload.notification.id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_NOTIFICATIONS_SAVE_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
